export function loadAiLearningContentDialogPlugin() {
  const translations = {
    en: {
      'ai-dialog-title': 'Generate Learning Text',
      'ai-label-goal': 'Learning goal',
      'ai-goal-placeholder': 'Select a goal',
      'goal-convey-title': 'Convey Knowledge',
      'goal-convey-desc': 'Deliver facts, definitions, and clear explanations in a structured format.',
      'goal-promote-title': 'Promote Behavior',
      'goal-promote-desc': 'Encourage action through instructions, benefits, and examples.',
      'goal-change-title': 'Change Attitude',
      'goal-change-desc': 'Change mindsets using storytelling, emotions, and reflection.',
      'ai-label-audience': 'Target Audience',
      'ai-audience-placeholder': 'Select audience',
      'aud-b1-title': 'Beginners & Non-Experts',
      'aud-b1-desc': 'Simple, clear, and encouraging explanations.',
      'aud-b2-title': 'Professionals & Experts',
      'aud-b2-desc': 'Factual, precise, and relevance-focused tone.',
      'aud-b3-title': 'Experienced Learners & Leaders',
      'aud-b3-desc': 'Reflective, sophisticated, and insight-driven style.',
      'aud-b4-title': 'Action-Oriented & Field Roles',
      'aud-b4-desc': 'Motivating, hands-on, and practical communication.',
      'ai-generate-btn-text': 'Generate'
    },
    de: {
      'ai-dialog-title': 'Strukturierten Lerntext erstelle',
      'ai-label-goal': 'Lernziel',
      'ai-goal-placeholder': 'Lernziel auswählen',
      'goal-convey-title': 'Wissen vermitteln',
      'goal-convey-desc': 'Fakten, Definitionen und Zusammenhänge strukturiert vermitteln.',
      'goal-promote-title': 'Verhalten fördern',
      'goal-promote-desc': 'Zu konkretem Handeln anregen – mit Anleitungen, Nutzenargumenten und Beispielen.',
      'goal-change-title': 'Einstellung verändern',
      'goal-change-desc': 'Perspektiven mit Storytelling, Emotionen und Reflexion beeinflussen.',
      'ai-label-audience': 'Zielgruppe',
      'ai-audience-placeholder': 'Zielgruppe auswählen',
      'aud-b1-title': 'Einsteiger & Nicht-Experten',
      'aud-b1-desc': 'Einfach, klar und ermutigend formuliert.',
      'aud-b2-title': 'Fachkräfte & Experten',
      'aud-b2-desc': 'Sachlich, präzise und relevant formuliert.',
      'aud-b3-title': 'Erfahrene Lernende & Führungskräfte',
      'aud-b3-desc': 'Reflektiert, anspruchsvoll und erkenntnisorientiert.',
      'aud-b4-title': 'Praxisorientierte & Außendienst',
      'aud-b4-desc': 'Motivierend, praktisch und direkt anwendbar.',
      'ai-generate-btn-text': 'Erstelle'
    },
    es:{
      'ai-dialog-title': 'Generar contenido de aprendizaje',
      'ai-label-goal': 'Objetivo de aprendizaje',
      'ai-goal-placeholder': 'Seleccionar objetivo',
      'goal-convey-title': 'Transmitir conocimientos',
      'goal-convey-desc': 'Transmitir hechos, definiciones y relaciones de forma estructurada.',
      'goal-promote-title': 'Fomentar comportamientos',
      'goal-promote-desc': 'Motivar a la acción mediante instrucciones, beneficios y ejemplos.',
      'goal-change-title': 'Cambiar actitudes',
      'goal-change-desc': 'Cambiar perspectivas a través de relatos, emociones y reflexión.',
      'ai-label-audience': 'Audiencia objetivo',
      'ai-audience-placeholder': 'Seleccionar audiencia',
      'aud-b1-title': 'Principiantes y no expertos',
      'aud-b1-desc': 'Explicaciones simples, claras y motivadoras.',
      'aud-b2-title': 'Profesionales y expertos',
      'aud-b2-desc': 'Tono preciso, informativo y enfocado en la relevancia.',
      'aud-b3-title': 'Aprendices avanzados y líderes',
      'aud-b3-desc': 'Estilo reflexivo, sofisticado y orientado al conocimiento.',
      'aud-b4-title': 'Equipos prácticos y de campo',
      'aud-b4-desc': 'Comunicación práctica, activa y motivadora.',
      'ai-generate-btn-text': 'Generar'
    },
    fr: {
      'ai-dialog-title': "Générer un contenu d’apprentissage",
      'ai-label-goal': 'Objectif pédagogique',
      'ai-goal-placeholder': 'Sélectionner un objectif',
      'goal-convey-title': 'Transmettre des connaissances',
      'goal-convey-desc': 'Transmettre des faits, des définitions et des relations de manière structurée.',
      'goal-promote-title': 'Favoriser des comportements',
      'goal-promote-desc': "Encourager l’action à travers des consignes, des bénéfices et des exemples.",
      'goal-change-title': 'Changer les attitudes',
      'goal-change-desc': 'Changer les perspectives par des récits, des émotions et des réflexions.',
      'ai-label-audience': 'Public cible',
      'ai-audience-placeholder': 'Sélectionner un public',
      'aud-b1-title': 'Débutants et non-experts',
      'aud-b1-desc': 'Explications simples, claires et encourageantes.',
      'aud-b2-title': 'Professionnels et experts',
      'aud-b2-desc': 'Tonalité factuelle, précise et centrée sur la pertinence.',
      'aud-b3-title': 'Apprenants expérimentés et dirigeants',
      'aud-b3-desc': 'Style réfléchi, sophistiqué et basé sur les idées.',
      'aud-b4-title': 'Apprenants terrain et orientés action',
      'aud-b4-desc': 'Communication motivante, concrète et directe.',
      'ai-generate-btn-text': 'Générer'
    },
    it: {
      'ai-dialog-title': 'Genera contenuto didattico',
      'ai-label-goal': 'Obiettivo di apprendimento',
      'ai-goal-placeholder': 'Seleziona un obiettivo',
      'goal-convey-title': 'Trasmettere conoscenze',
      'goal-convey-desc': 'Trasmettere fatti, definizioni e collegamenti in modo strutturato.',
      'goal-promote-title': 'Promuovere comportamenti',
      'goal-promote-desc': "Favorire l’azione con istruzioni, vantaggi pratici ed esempi concreti.",
      'goal-change-title': 'Modificare atteggiamenti',
      'goal-change-desc': 'Cambiare prospettive con narrazione, emozioni e riflessione.',
      'ai-label-audience': 'Pubblico di destinazione',
      'ai-audience-placeholder': 'Seleziona il pubblico',
      'aud-b1-title': 'Principianti e non esperti',
      'aud-b1-desc': 'Spiegazioni semplici, chiare e incoraggianti.',
      'aud-b2-title': 'Professionisti ed esperti',
      'aud-b2-desc': 'Tono preciso, informativo e rilevante.',
      'aud-b3-title': 'Discenti esperti e leader',
      'aud-b3-desc': "Stile riflessivo, sofisticato e basato sull’insight.",
      'aud-b4-title': 'Ruoli pratici e sul campo',
      'aud-b4-desc': 'Comunicazione pratica, stimolante e diretta.',
      'ai-generate-btn-text': 'Genera'
    },
    pl: {
      'ai-dialog-title': 'Wygeneruj treść edukacyjną',
      'ai-label-goal': 'Cel edukacyjny',
      'ai-goal-placeholder': 'Wybierz cel',
      'goal-convey-title': 'Przekazywanie wiedzy',
      'goal-convey-desc': 'Przekazywanie faktów, definicji i zależności w uporządkowany sposób.',
      'goal-promote-title': 'Wspieranie zachowań',
      'goal-promote-desc': 'Zachęcanie do działania poprzez instrukcje, korzyści i przykłady.',
      'goal-change-title': 'Zmiana postawy',
      'goal-change-desc': 'Zmiana perspektywy poprzez opowieści, emocje i refleksję.',
      'ai-label-audience': 'Grupa docelowa',
      'ai-audience-placeholder': 'Wybierz grupę',
      'aud-b1-title': 'Początkujący i osoby bez doświadczenia',
      'aud-b1-desc': 'Proste, jasne i zachęcające wyjaśnienia.',
      'aud-b2-title': 'Profesjonaliści i eksperci',
      'aud-b2-desc': 'Ton rzeczowy, precyzyjny i skupiony na istotnych treściach.',
      'aud-b3-title': 'Doświadczeni uczestnicy i liderzy',
      'aud-b3-desc': 'Styl refleksyjny, zaawansowany i oparty na analizie.',
      'aud-b4-title': 'Osoby praktyczne i terenowe',
      'aud-b4-desc': 'Komunikacja motywująca, konkretna i nastawiona na działanie.',
      'ai-generate-btn-text': 'Generuj'
    },
    ro: {
      'ai-dialog-title': 'Generează text educațional',
      'ai-label-goal': 'Obiectiv de învățare',
      'ai-goal-placeholder': 'Selectați un obiectiv',
      'goal-convey-title': 'Transmite cunoștințe',
      'goal-convey-desc': 'Oferă fapte, definiții și explicații clare într-un format structurat.',
      'goal-promote-title': 'Promovează comportamentul',
      'goal-promote-desc': 'Încurajează acțiunea prin instrucțiuni, beneficii și exemple.',
      'goal-change-title': 'Schimbă atitudinea',
      'goal-change-desc': 'Schimbă mentalități folosind povestiri, emoții și reflecție.',
      'ai-label-audience': 'Potrivirea audienței',
      'ai-audience-placeholder': 'Selectează audiența',
      'aud-b1-title': 'Începători & Non-experți',
      'aud-b1-desc': 'Explicații simple, clare și încurajatoare.',
      'aud-b2-title': 'Profesioniști & Experți',
      'aud-b2-desc': 'Ton factual, precis și concentrat pe relevanță.',
      'aud-b3-title': 'Cursanți Experimentați & Lideri',
      'aud-b3-desc': 'Stil reflectiv, sofisticat și bazat pe înțelegere.',
      'aud-b4-title': 'Orientat spre Acțiune & Roluri de Teren',
      'aud-b4-desc': 'Comunicare motivantă, practică și hands-on.',
      'ai-generate-btn-text': 'Generează'
    },
    cz: {
      'ai-dialog-title': 'Generovat výukový text',
      'ai-label-goal': 'Vzdělávací cíl',
      'ai-goal-placeholder': 'Vyberte cíl',
      'goal-convey-title': 'Předávání znalostí',
      'goal-convey-desc': 'Předávejte fakta, definice a jasné vysvětlení ve strukturovaném formátu.',
      'goal-promote-title': 'Podpora chování',
      'goal-promote-desc': 'Podporujte akci prostřednictvím instrukcí, výhod a příkladů.',
      'goal-change-title': 'Změna postoje',
      'goal-change-desc': 'Měňte myšlení pomocí vyprávění, emocí a reflexe.',
      'ai-label-audience': 'Vhodnost pro publikum',
      'ai-audience-placeholder': 'Vyberte publikum',
      'aud-b1-title': 'Začátečníci & neodborníci',
      'aud-b1-desc': 'Jednoduché, jasné a povzbuzující vysvětlení.',
      'aud-b2-title': 'Profesionálové & Experti',
      'aud-b2-desc': 'Faktický, přesný a zaměřený na relevanci tón.',
      'aud-b3-title': 'Zkušení studenti & Lídři',
      'aud-b3-desc': 'Reflexivní, sofistikovaný a zaměřený na vhledy styl.',
      'aud-b4-title': 'Akčně orientovaní & Terénní role',
      'aud-b4-desc': 'Motivující, praktická a hands-on komunikace.',
      'ai-generate-btn-text': 'Generovat'
    },
    nl: {
      'ai-dialog-title': 'Leertekst genereren',
      'ai-label-goal': 'Leerdoel',
      'ai-goal-placeholder': 'Selecteer een doel',
      'goal-convey-title': 'Kennis overbrengen',
      'goal-convey-desc': 'Feiten, definities en duidelijke uitleg op een gestructureerde manier presenteren.',
      'goal-promote-title': 'Gedrag bevorderen',
      'goal-promote-desc': 'Aanzetten tot actie via instructies, voordelen en voorbeelden.',
      'goal-change-title': 'Houding veranderen',
      'goal-change-desc': 'Denkwijzen veranderen via storytelling, emoties en reflectie.',
      'ai-label-audience': 'Doelgroep',
      'ai-audience-placeholder': 'Selecteer doelgroep',
      'aud-b1-title': 'Beginners & niet-experts',
      'aud-b1-desc': 'Eenvoudige, duidelijke en bemoedigende uitleg.',
      'aud-b2-title': 'Professionals & experts',
      'aud-b2-desc': 'Feitelijke, nauwkeurige en relevantie-gerichte toon.',
      'aud-b3-title': 'Ervaren leerders & leiders',
      'aud-b3-desc': 'Reflectieve, geavanceerde en inzichtgerichte stijl.',
      'aud-b4-title': 'Actiegerichte & veldmedewerkers',
      'aud-b4-desc': 'Motiverende, praktische en hands-on communicatie.',
      'ai-generate-btn-text': 'Genereren'
    },
    tr: {
      'ai-dialog-title': 'Öğrenme metni oluştur',
      'ai-label-goal': 'Öğrenme hedefi',
      'ai-goal-placeholder': 'Bir hedef seçin',
      'goal-convey-title': 'Bilgi Aktarımı',
      'goal-convey-desc': 'Yapılandırılmış bir biçimde gerçekler, tanımlar ve net açıklamalar sunun.',
      'goal-promote-title': 'Davranış Geliştirme',
      'goal-promote-desc': 'Talimatlar, faydalar ve örnekler aracılığıyla harekete geçmeyi teşvik edin.',
      'goal-change-title': 'Tutum Değişikliği',
      'goal-change-desc': 'Hikaye anlatımı, duygular ve yansıma yoluyla bakış açılarını değiştirin.',
      'ai-label-audience': 'Hedef Kitle',
      'ai-audience-placeholder': 'Kitle seçin',
      'aud-b1-title': 'Yeni Başlayanlar & Uzman Olmayanlar',
      'aud-b1-desc': 'Basit, anlaşılır ve teşvik edici açıklamalar.',
      'aud-b2-title': 'Profesyoneller & Uzmanlar',
      'aud-b2-desc': 'Gerçekçi, kesin ve alaka odaklı ton.',
      'aud-b3-title': 'Deneyimli Öğrenenler & Liderler',
      'aud-b3-desc': 'Düşündürücü, sofistike ve içgörü odaklı stil.',
      'aud-b4-title': 'Eyleme Yönelik & Saha Rolleri',
      'aud-b4-desc': 'Motive edici, pratik ve uygulamalı iletişim.',
      'ai-generate-btn-text': 'Oluştur'
    },
  };

  FroalaEditor.POPUP_TEMPLATES["aiDialog.popup"] = '[_CUSTOM_LAYER_]';

  // Shared state across ALL editor instances
  const dialogId = 'ai-learning-content-dialog';

  // Track which editor instances have the popup registered
  const registeredEditors = new WeakSet();

  // Store the dialog HTML template for reuse across editors
  const getDialogHtml = () => `
    <div id="${dialogId}" class="ai-dialog">
      <div class="ai-dialog-content">
        <div class="ai-dialog-header">
          <div class="ai-dialog-label">
            <img src="/assets/images/froala-plugins/ai.icon.png" alt="Info" class="ai-label-icon" />
            <span id="ai-dialog-title">Learning Content Generator</span>
          </div>
          <span class="ai-close-icon material-icons">close</span>
        </div>
        <div class="ai-dropdowns">
          <div>
            <label><span class="material-icons">radar</span><span id="ai-label-goal">Learning goal</span></label>
            <div class="custom-select" id="learning-goal">
              <div class="custom-select-selected">
                <span class="selected-text" id="ai-goal-placeholder">Select a goal</span>
                <span class="dropdown-icon material-icons">expand_more</span>
              </div>
              <div class="custom-select-options">
                <div class="custom-select-option" data-value="convey">
                  <div class="option-title" id="goal-convey-title">Convey Knowledge</div>
                  <div class="description" id="goal-convey-desc">Focus on facts, definitions, clear explanations, and structured presentation</div>
                </div>
                <div class="custom-select-option" data-value="promote">
                  <div class="option-title" id="goal-promote-title">Promote Behavior</div>
                  <div class="description" id="goal-promote-desc">Aim to encourage specific actions using instructions, practical benefits, and concrete examples</div>
                </div>
                <div class="custom-select-option" data-value="change">
                  <div class="option-title" id="goal-change-title">Change Attitude</div>
                  <div class="description" id="goal-change-desc">Intend to shift perspectives or beliefs through storytelling, emotional appeal, and reflection</div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <label><span class="material-icons">support_agent</span><span id="ai-label-audience">Audience fit</span></label>
            <div class="custom-select" id="audience-fit">
              <div class="custom-select-selected">
                <span class="selected-text" id="ai-audience-placeholder">Select audience</span>
                <span class="dropdown-icon material-icons">expand_more</span>
              </div>
              <div class="custom-select-options">
                <div class="custom-select-option" data-value="b1">
                  <div class="option-title" id="aud-b1-title">Beginners, non-experts</div>
                  <div class="description" id="aud-b1-desc">simple, clear explanations, encouraging</div>
                </div>
                <div class="custom-select-option" data-value="b2">
                  <div class="option-title" id="aud-b2-title">Professionals, experts, compliance-driven audiences</div>
                  <div class="description" id="aud-b2-desc">factual, precise, clear, relevant</div>
                </div>
                <div class="custom-select-option" data-value="b3">
                  <div class="option-title" id="aud-b3-title">Experienced learners, managers, thought leaders</div>
                  <div class="description" id="aud-b3-desc">expect reflective, sophisticated, insight-driven</div>
                </div>
                <div class="custom-select-option" data-value="b4">
                  <div class="option-title" id="aud-b4-title">Action-oriented learners, sales teams, field staff</div>
                  <div class="description" id="aud-b4-desc">energizing, hands-on, motivating, practical focus</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ai-dialog-actions">
          <button class="ai-generate-btn">
            <span class="material-icons">auto_fix_high</span>
            <span id="ai-generate-btn-text">Generate</span>
          </button>
        </div>
      </div>
    </div>
  `;

  FroalaEditor.PLUGINS.aiLearningContent = function (editor) {
    // Get the popup container for this specific editor
    function getPopupContainer(targetEditor) {
      const $popup = targetEditor.popups.get('aiDialog.popup');
      return $popup ? $popup[0] : null;
    }

    function applyTranslations(targetEditor) {
      const container = getPopupContainer(targetEditor);
      if (!container) return;

      const lang = targetEditor?.opts?.language || 'en';
      const t = translations[lang] || translations['en'];
      for (const key in t) {
        const el = container.querySelector(`#${key}`);
        if (el) el.textContent = t[key];
      }
    }

    function initCustomSelect(targetEditor, selectId) {
      const container = getPopupContainer(targetEditor);
      if (!container) return;

      const select = container.querySelector(`#${selectId}`);
      if (!select) return;

      const selected = select.querySelector('.custom-select-selected');
      const options = select.querySelectorAll('.custom-select-option');

      selected.onmousedown = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const isOpen = select.classList.toggle('open');
        const icon = selected.querySelector('.dropdown-icon');
        icon.textContent = isOpen ? 'expand_less' : 'expand_more';
        closeOtherSelects(targetEditor, selectId);
        return false;
      };

      options.forEach(option => {
        option.onmousedown = (e) => {
          e.stopPropagation();
          e.preventDefault();
          const label = option.querySelector('.option-title').textContent;
          const selectedText = selected.querySelector('.selected-text');
          selectedText.textContent = label;

          options.forEach(opt => opt.classList.remove('selected'));
          option.classList.add('selected');
          select.classList.remove('open');
          const icon = selected.querySelector('.dropdown-icon');
          icon.textContent = 'expand_more';
          return false;
        };
      });
    }

    function closeOtherSelects(targetEditor, exceptId) {
      const container = getPopupContainer(targetEditor);
      if (!container) return;

      container.querySelectorAll('.custom-select').forEach(select => {
        if (select.id !== exceptId) {
          select.classList.remove('open');
          const icon = select.querySelector('.dropdown-icon');
          if (icon) icon.textContent = 'expand_more';
        }
      });
    }

    const setupEventHandlers = function(targetEditor) {
      const container = getPopupContainer(targetEditor);
      if (!container) return;

      const dialog = container.querySelector('.ai-dialog');
      if (!dialog) return;

      // Remove old event listeners by cloning and replacing
      const closeIcon = dialog.querySelector('.ai-close-icon');
      const generateBtn = dialog.querySelector('.ai-generate-btn');

      if (closeIcon) {
        const newCloseIcon = closeIcon.cloneNode(true);
        closeIcon.parentNode.replaceChild(newCloseIcon, closeIcon);
        newCloseIcon.addEventListener('click', () => {
          targetEditor.popups.hide('aiDialog.popup');
        });
      }

      if (generateBtn) {
        const newGenerateBtn = generateBtn.cloneNode(true);
        generateBtn.parentNode.replaceChild(newGenerateBtn, generateBtn);
        newGenerateBtn.addEventListener('click', () => {
          const goalValue = dialog.querySelector('#learning-goal .selected-text').textContent.trim();
          const audienceValue = dialog.querySelector('#audience-fit .selected-text').textContent.trim();
          targetEditor.selection.restore();
          targetEditor.events.trigger('aiLearningContent.generateClicked', [{ goal: goalValue, audience: audienceValue }, targetEditor]);
          targetEditor.popups.hide('aiDialog.popup');
        });
      }

    };

    const buildDialog = function (editorInstance) {
      const targetEditor = editorInstance || editor;

      // Skip if already registered for this editor
      if (registeredEditors.has(targetEditor)) {
        return;
      }

      // Create popup for this editor instance using the shared template
      targetEditor.popups.create('aiDialog.popup', {
        custom_layer: getDialogHtml()
      });

      registeredEditors.add(targetEditor);
    };

    const openDialog = function (editorInstance) {
      const targetEditor = editorInstance || editor;
      this.buildDialog(targetEditor);
      targetEditor.popups.setContainer('aiDialog.popup', targetEditor.$tb);

      const $toolbar = targetEditor.$tb;
      const popupWidth = 500 + 8;
      const popupHeight = 2;

      const left = $toolbar.offset().left + $toolbar.outerWidth() - popupWidth;
      const top = $toolbar.offset().top - popupHeight;

      targetEditor.popups.show('aiDialog.popup', left, top, $toolbar);

      // Setup event handlers and initialize UI after popup is shown
      // setTimeout ensures Froala finishes rendering the popup before we interact with it
      setTimeout(() => {
        applyTranslations(targetEditor);
        initCustomSelect(targetEditor, 'learning-goal');
        initCustomSelect(targetEditor, 'audience-fit');
        setupEventHandlers(targetEditor);
      }, 0);
    };

    return {
      openDialog,
      buildDialog
    };
  };

  FroalaEditor.DefineIcon('aiLearningContentIcon', {
    SRC: '/assets/images/froala-plugins/ai.icon.png',
    ALT: 'Generator',
    template: 'image'
  });

  FroalaEditor.RegisterCommand('aiLearningContent', {
    title: 'AI Generator',
    type: 'button',
    icon: 'aiLearningContentIcon',
    callback: function () {
      this.aiLearningContent.openDialog(this);
    },
    refresh: function ($btn) {
      const selectedText = this.selection?.get()?.toString() || '';
      $btn.toggleClass('fr-disabled', !selectedText.trim());
    }
  });
}
